import React from 'react';

const AboutUs = () => {
    return (
        <div className="py-5 my-5 text-center">
            <h1 > Working On this Page Back to  Coming Very Soon</h1>
        </div>
    );
};

export default AboutUs;